export default __webpack_public_path__ + "static/media/link-card-example.e5d55385.png";